import { DayVenueActivityViewModel, WorkspaceReservationMethod } from "Services/API/API";
import { formatReservationTime } from "Utils/datetime";
import moment from "moment";
import React from "react";
import * as Icons from "Components/Icons";
import { GuestAvatarList } from "./GuestAvatarList";
import classNames from "classnames";

export enum ActivityType {
   My,
   Coworker
}

interface ActivityRowProps {
   activity: DayVenueActivityViewModel;
   activeDate: moment.Moment;
   activityType: ActivityType;
   onActivityClick: (activity: DayVenueActivityViewModel) => void
}

export const ActivityRow: React.FC<ActivityRowProps> = ({ activity, activeDate, activityType, onActivityClick }) => {
   const getTimeDate = (activity: DayVenueActivityViewModel) => {
      return activity.reservationType == WorkspaceReservationMethod.Period
         ? moment(activity.startDate).isSame(activeDate, "month")
            ? `${moment(activity.startDate).format("MMM")} ${moment(activity.startDate).format("D")}-${moment(activity.startDate).endOf("month").format("D")}`
            : `${activeDate.format("MMM")} ${moment(activeDate).startOf("month").format("D")}-${moment(activeDate).endOf("month").format("D")}`
         : moment().isSame(activity.startDate, "day")
            ? "Today"
            : moment(activity.startDate).format("dddd, MMM D");
   }

   const getTimeHour = (activity: DayVenueActivityViewModel) => {
      return activity.reservationType != WorkspaceReservationMethod.Period && activity.endDate
         ? <>{formatReservationTime(activity.startDate, activity.endDate)} {activity.occurrenceDate ? <Icons.Loop /> : ""}</>
         : activity.endDate
            ? `Ends ${moment(activity.endDate).format("MMMM D, YYYY")}`
            : "Autorenews";
   }

   return <div className="activity-row card" onClick={() => onActivityClick(activity)}>
      <div className="activity-row-image" style={{ backgroundImage: `url(${activity.imageUrl})` }}></div>
      <div className="activity-row-content">
         <div className="activity-row-location">
            <div className="activity-row-location-name" title={activity.venueName}>{activity.venueName}</div>
            <div className="activity-row-location-address" title={activity.venueAddress}>{activity.venueAddress}</div>
         </div>
         <div className="activity-row-space text-truncate">
            <div><Icons.Space width={24} /></div>
            <div className="text-truncate">
               <div className="activity-row-space-name text-truncate" title={activity.hasMultipleSpace ? "Multiple workspaces" : activity.spaceName}>{activity.hasMultipleSpace ? "Multiple workspaces" : activity.spaceName}</div>
               {!activity.hasMultipleSpace && <div className="activity-row-space-type text-truncate" title={activity.spaceType}>{activity.spaceType}</div>}
            </div>
         </div>
         <div className="activity-row-time">
            <div className="activity-row-time-icon">
               <Icons.Clock />
            </div>
            <div className="activity-row-time-inner">
               <div className="activity-row-time-date">{getTimeDate(activity)}</div>
               <div className="activity-row-time-hour">{getTimeHour(activity)}</div>
            </div>
         </div>
         <GuestAvatarList guests={activity.coworkers} capacity={0} title="Coworkers" className={classNames("activity-row-invitees")} extendOnHover={activityType == ActivityType.Coworker} />
         <div className="activity-row-action">
            <a href="#" onClick={(e) => { e.preventDefault(); }}>{activityType == ActivityType.Coworker ? "Work here" : "View"}</a>
         </div>
      </div>
   </div>
}